import React from 'react';
import styles from '../../styles.module.css';
import MainIcons from '@/icons/main';

export default function ArrowIconRotate() {
  return (
    <MainIcons.arrowIcon width="12px" height="12px" className={`${styles.chevron} arrowIcon`} />
  );
}
